// 创建链式调用
// @author CAIHUAZHI <huazhi.chz@alibaba-inc.com>
// @create 2019/12/30 14:17
/**
 * 创建链式调用
 */
export function createApplyChain(middlewares, scope) {
    return async function (options) {
        let index = 0;
        return await Object.assign(Object.assign({}, options), { async next(params) {
                const fn = middlewares[index++];
                if (!fn) {
                    return delete this.next, this;
                }
                return await fn.call(scope, this, params), this;
            } }).next();
    };
}
